import { type OpportunitiesFilterParamsType } from '@/modules/Opportunities';
import { type QueryProviderQuery } from '@/modules/QueryProvider';
import joinNonEmptyParams from '@/utils/joinNonEmptyParams';

export default function createOpportunitiesFetcherKey({
  ownerOrgId,
  // Unless specifically defined, retrieve all
  pageSize = 1000,
  page = 1,
  sortBy,
  sortOrder,

  archived,
  assigneeIds,
  campaignId,
  confidenceLevelId,
  confidenceLevelIds,
  constituentCategories,
  constituentId,
  constituentLabelIds,
  constituentType,
  opportunityLabelIds,
  opportunityStageId,
  opportunityStageIds,
  ownerIds,
}: {
  ownerOrgId: string;
  page?: QueryProviderQuery['page'];
  pageSize?: QueryProviderQuery['pageSize'];
  sortBy?: QueryProviderQuery['sortBy'];
  sortOrder?: QueryProviderQuery['sortOrder'];

  archived?: boolean;
  assigneeIds?: QueryProviderQuery<OpportunitiesFilterParamsType>['assigneeIds'];
  campaignId?: QueryProviderQuery<OpportunitiesFilterParamsType>['campaignId'];
  confidenceLevelId?: string;
  confidenceLevelIds?: QueryProviderQuery<OpportunitiesFilterParamsType>['confidenceLevelIds'];
  constituentCategories?: QueryProviderQuery<OpportunitiesFilterParamsType>['constituentCategories'];
  constituentId?: string;
  constituentLabelIds?: QueryProviderQuery<OpportunitiesFilterParamsType>['constituentLabelIds'];
  constituentType?: QueryProviderQuery<OpportunitiesFilterParamsType>['constituentType'];
  opportunityLabelIds?: QueryProviderQuery<OpportunitiesFilterParamsType>['opportunityLabelIds'];
  opportunityStageId?: string;
  opportunityStageIds?: QueryProviderQuery<OpportunitiesFilterParamsType>['opportunityStageIds'];
  ownerIds?: QueryProviderQuery<OpportunitiesFilterParamsType>['ownerIds'];
}) {
  if (!ownerOrgId) return null;

  return `opportunities?${joinNonEmptyParams({
    pageFrom: page ? (page - 1) * pageSize : 0,
    pageSize,
    sortBy,
    sortOrder,
    ownerOrgId,

    archived,
    assigneeIds,
    campaignId,
    confidenceLevelId,
    confidenceLevelIds,
    constituentCategories,
    constituentId,
    constituentLabelIds,
    constituentType,
    opportunityLabelIds,
    opportunityStageId,
    opportunityStageIds,
    ownerIds,
  })}`;
}
